module.exports = __webpack_public_path__ + "img/1sb-tag-icon.55cc8df.svg";